import type { AnimationProperties, AnimationsKit } from '../../../../types';

const name = 'ExpandIn';
const properties: AnimationProperties = {
  hideOnStart: true,
  viewportThreshold: 0.15,

  groups: ['entrance', 'animation'],
  schema: {
    duration: {
      type: 'number',
      min: 0,
      default: 0,
    },
    delay: {
      type: 'number',
      min: 0,
      default: 0,
    },
    power: {
      type: 'string',
      enum: ['soft', 'medium', 'hard'],
      default: 'hard',
    },
  },
};

const scaleMap = {
  soft: 0.85,
  medium: 0.4,
  hard: 0,
};

function animate(
  kit: AnimationsKit,
  elements: HTMLElement[],
  duration: number,
  delay: number,
  {
    power = properties.schema.power.default,
    ...params
  }: { power?: keyof typeof scaleMap } = {},
) {
  const sequence = kit.sequence(params);
  const scale = scaleMap[power];

  sequence.add(
    kit.animate('BaseFade', elements, 0, 0, { to: { opacity: 0.01 } }),
  );
  sequence.add([
    kit.animate('BaseFade', elements, duration, delay, {
      to: {
        opacity: 1,
      },
      ease: 'Cubic.easeIn',
    }),
    kit.animate('BaseScale', elements, duration, delay, {
      from: { scale },
      ease: 'Sine.easeIn',
      immediateRender: false,
    }),
  ]);
  return sequence.get();
}

export { name, properties, animate };
